
import React from "react";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ChallengeSection from "./components/ChallengeSection";
import ProgrammeSection from "./components/ProgrammeSection";
import ServicesSection from "./components/ServicesSection";
import FacilitiesSection from "./components/FacilitiesSection";
import DoctorsSection from "./components/DoctorsSection";
import ProceduresSection from "./components/ProceduresSection";
import ClinicsSection from "./components/ClinicsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Gallery from "./components/Gallery";
import Esg from "./components/ESG/LapsleeveGastrectomy";

import Endoscopic from "./components/ESG/Endoscopic";
import { BrowserRouter } from "react-router-dom";
import Layout from "./Layout";


function App() {
  return (
   <Layout/>
 
  );
}

export default App;
